// extracted by mini-css-extract-plugin
module.exports = {"add":"styles_add__6Db7A","active":"styles_active__3sSmV"};